import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { CheckCircle } from "@phosphor-icons/react";

const points = [
  "Reach verified B2B buyers — retailers, exporters, and workshop chains — not tyre-kickers.",
  "Your identity and cost data stay private until you agree to a deal.",
  "We sanitize your inventory file so only buyer-safe data is ever shared.",
  "Every transaction is escrow-backed, so you get paid on the buyer's sign-off.",
  "Transparent success fee — you only pay when your lot sells.",
];

export default function SellWithUs() {
  const { user } = useAuth();
  const cta = user ? (user.role === "buyer" ? "/account" : "/seller/new") : "/register";
  return (
    <div>
      <section className="border-b border-border bg-navy py-16 text-white">
        <div className="mx-auto grid max-w-7xl items-center gap-10 px-5 lg:grid-cols-2 lg:px-8">
          <div>
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-brand">Sell with SparesHub</span>
            <h1 className="mt-3 font-display text-4xl font-black tracking-tighter sm:text-5xl">Turn dead stock into a clean exit.</h1>
            <p className="mt-4 max-w-xl text-lg text-white/70">Closing a branch, holding overstock, or exiting a segment? Submit your lot and let SparesHub manage verification, sanitization, buyer outreach, and escrow closure.</p>
            <Button asChild className="mt-8 h-12 rounded-sm bg-brand px-7 text-base font-semibold text-white hover:bg-brand-hover" data-testid="sell-cta">
              <Link to={cta}>{user && user.role !== "buyer" ? "Submit a lot" : "Register as a seller"}</Link>
            </Button>
          </div>
          <div className="rounded-sm border border-white/10 bg-white/5 p-8 backdrop-blur-md">
            <h3 className="font-display text-lg font-bold">Why sellers choose us</h3>
            <ul className="mt-5 space-y-4">
              {points.map((p) => (
                <li key={p} className="flex items-start gap-3 text-sm text-white/80">
                  <CheckCircle weight="fill" className="mt-0.5 h-5 w-5 shrink-0 text-ok" /> {p}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
      <section className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
        <div className="grid gap-px overflow-hidden rounded-sm border border-border md:grid-cols-3">
          {[
            { k: "₹5 L+", v: "Minimum lot MRP value to list" },
            { k: "48 hrs", v: "Typical verification turnaround" },
            { k: "Escrow", v: "Every deal, guaranteed settlement" },
          ].map((s) => (
            <div key={s.k} className="bg-navy-50 p-10 text-center">
              <div className="stat text-3xl font-bold text-navy">{s.k}</div>
              <div className="mt-1 text-sm text-muted-foreground">{s.v}</div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
